import { createApp } from 'vue'
import App from './App.vue'

// Suppress benign ResizeObserver warnings from Vuetify menus (shown by webpack overlay otherwise)
const resizeObserverErr = /ResizeObserver loop/;
const suppressResizeObserver = (event) => {
  const message = event?.message || event?.reason?.message || String(event?.reason || '');
  if (resizeObserverErr.test(message)) {
    event.stopImmediatePropagation?.();
    event.preventDefault?.();
    return true;
  }
  return false;
};
window.addEventListener('error', suppressResizeObserver);
window.addEventListener('unhandledrejection', suppressResizeObserver);

// Config
import { useCreatedVuetify } from "@/setup/vuetify";
import { useCreatedRouter } from "@/setup/router";
import { createPinia } from "pinia";
import mitt from "mitt";

// Stores

// Custom Components
import dataTable from "@/components/dataTable";
import simpleDialog from "@/components/dialog/simpleDialog";
import datePicker from "@/components/datePicker";
import snackBar from "@/components/snackBar/snackBar.js";
import loader from "@/components/dialog/loadingDialog/loadingDialog.js"
import confirmDialog from "@/components/dialog/confirmDialog/confirmDialog.js"
import inputDialog from "@/components/dialog/inputDialog/inputDialog.js";
import ZoomOnHover from 'vue-zoom-on-hover';

const pinia = createPinia();
const emitter = mitt();
const app = createApp(App);

app.use(useCreatedVuetify);
app.use(pinia);
app.use(useCreatedRouter);

// Using MITT to emit and listen to events
app.config.globalProperties.$emitter = emitter;
app.provide("emitter", emitter);

app.use(snackBar);
app.use(loader);
app.use(confirmDialog);
app.use(inputDialog);

app.component("DataTable", dataTable);
app.component("SimpleDialog", simpleDialog);
app.component("DatePicker", datePicker);
app.component('ZoomOnHover', ZoomOnHover);

app.mount('#app')
